module.exports = __webpack_public_path__ + "static/media/Vindermere Town View2.ab84b91a.jpg";